export const ja = {
  // Upload step
  uploadTitle: '空間の写真をアップロード',
  uploadHint: 'クリックまたは画像をドラッグ&ドロップ',
  uploadHintTouch: 'タップして写真を選ぶ',
  uploadOr: 'または',
  takePhoto: '写真を撮る',
  yourPhotos: 'アップロードした写真',
  photoLabel: '写真 {n}',
  photoCount: '写真{n}枚',
  addPhoto: '写真を追加',
  continue: '次へ',
  stepLabel: 'ステップ {current} / {total}',

  // Style step
  chooseStyle: 'インテリアスタイルを選択',
  describeCustomStyle: 'お好みのスタイルを直接ご記入ください',
  uploadReferenceTitle: 'リファレンス写真をアップロード',
  uploadReferenceHint: 'AI がこの写真のトーン・素材・雰囲気を再現します。元の部屋写真はそのままです。',
  removeReference: 'リファレンスを削除',
  cleanupOptionTidy: '片付けだけ',
  cleanupOptionTidyDesc: '家具はそのまま、散らかりやゴミ・乱雑な物だけ整理',
  layoutOptionFlow: '動線優先',
  layoutOptionFlowDesc: '通行しやすいように家具配置を整えます',
  layoutOptionSpacious: '広く見せる',
  layoutOptionSpaciousDesc: '視線が抜けて圧迫感が減り、より広く感じます',
  // 평면도 모드 (2.4.0)
  planChooseOption: '間取り図から何を作りますか？',
  planOption_3d: '3D間取り図',
  planOption_3dDesc: '家全体を上から見た3Dに、スタイルをつけて',
  planOption_room: '部屋をひとつ',
  planOption_roomDesc: '間取り図で部屋を塗ると、その部屋を目線の高さで',
  planOption_clean: '図面をきれいに',
  planOption_cleanDesc: '手描きやぼやけた図面をきれいに描き直します',
  planCleanKindTitle: '図面の種類',
  planCleanKind_line: '白黒の図面',
  planCleanKind_color: 'カラー間取り図',
  planStyleTitle: 'スタイル',
  planRoomTitle: 'どの部屋を見ますか？',
  planRoomSignIn: 'ログインすると間取り図から部屋を選べます。',
  planRoomPaint: '間取り図で部屋を塗る',
  planRoomPicked: '選んだ部屋',
  planRoomRepaint: '塗り直す',
  planRoomClear: '消す',
  planRoomNamePlaceholder: 'または部屋の名前（例：主寝室）',
  planCropHint: '写真を間取り図だけに切り取ると、より正確になります。',
  planFirstOnly: '間取り図は1枚目の写真だけを使います。',
  planRoomPickTitle: '部屋を選ぶ',
  planRoomPickHint: '見たい部屋を指で塗ってください。ざっくりで大丈夫です。',
  planRoomPickDone: 'この部屋にする',
  planRoomNeedPick: '間取り図で部屋を塗るか、部屋の名前を入力してください。',
  errNotFloorplan: '間取り図ではないようです。間取り図をアップロードするか、別のスタイルを選んでください。',
  planRoomFrom: '間取り図で選んだ部屋',
  planInputLabel: '間取り図',
  planOutput_plan_3d: '3D間取り図',
  planOutput_plan_room: '部屋ビュー',
  planOutput_plan_clean: 'きれいな図面',
  planOutput_plan_color: 'カラー間取り図',
  planRoomFromResult: '部屋を選んで見る',
  planRoomMake: 'この部屋を作る',
  planRoomMeta: 'クレジット {n} · 同じ家のこの部屋を目線の高さで',
  layoutChooseOption: '配置の方向を選択',
  cleanupOptionEmpty: '空室にする',
  cleanupOptionEmptyDesc: '家具とインテリアを全て撤去。壁・床・窓はそのまま',
  cleanupChooseOption: '掃除方法を選択',
  creditEarnHint: '毎日ログインで +1、友達招待で +5 クレジット獲得。',
  languageHint: '分析結果もこの言語で表示されます。',
  reuseStyle: '— 以前のスタイルを再利用 —',
  customPlaceholder: "ご希望のインテリアスタイルを詳しくご記入ください (例:「温かみのある木目調の落ち着いたスタイル」「メタルのアクセントが効いたフューチャリスティック・ミニマル」)",
  customStylePublicHint: 'カスタムスタイルの文章は匿名でコミュニティに公開されることがあります。アカウント設定でオフにできます。',
  communityRankTitle: 'トレンドスタイル',
  communityPeople: '{n}人が使用',
  customStylesChip: 'カスタムスタイル',
  galleryRecentBadge: 'たった今使用',
  timeJustNow: 'たった今',
  timeAgoMin: '{n}分前',
  timeAgoHour: '{n}時間前',
  communityViewAll: 'すべて見る',
  galleryTitle: 'トレンドスタイル',
  briefsLabel: 'お知らせ',
  briefTopupKicker: 'クレジット',
  briefTopupTitle: '次のデザインにはクレジットが足りません',
  briefTopupLine: '無料分は明日また補充。今すぐ使うならクレジットパック。',
  briefSeasonKicker: '季節限定',
  briefSeasonTitle: '{name}スタイルが登場',
  briefSeasonLine: '数週間だけの季節限定スタイルです。',
  briefInviteKicker: '友だち招待',
  briefInviteTitle: '友だちを招待すると、ふたりとも+{n}クレジット',
  briefInviteLine: 'リンクを送るだけ。友だちが登録するとクレジットが届きます。',
  galleryEmpty: 'この空間のトレンドはまだありません。使われ始めるとここに表示されます。',
  galleryBuiltinTitle: '最近のスタイルランキング',
  galleryPopularCustom: '最近人気のカスタム',
  galleryDiscoverTitle: 'カスタムを見つける',
  galleryShuffle: 'シャッフル',
  galleryTranslate: '翻訳して表示',
  galleryTranslating: '翻訳中…',
  galleryOriginal: '原文を表示',
  galleryLiveTab: 'ライブ',
  galleryLiveWaiting: '新しいスタイルを待っています…',
  galleryLiveTitle: 'いま使われています',
  galleryRecentCustom: '最近のカスタムスタイル',
  galleryUse: 'このスタイルを使う',
  styleShareNotice: 'カスタムスタイルの文章は匿名でコミュニティに公開されることがあります。',
  styleShareNoticeSettings: '設定でオフ',
  styleShareNoticeOk: 'OK',
  communityTopTitle: '人気のカスタムスタイル',
  communityRecentTitle: 'いま他の人が使ったスタイル',
  communityUses: '{n}回使用',
  communityDesigns: 'デザイン{n}件',
  communityDesignsOne: 'デザイン{n}件',
  styleShareTitle: 'カスタムスタイルの公開',
  styleShareDesc: '自分の書いたカスタムスタイル文を他の人が発見して試せるようにします。写真は公開されません。',
  additionalRequests: '追加リクエスト',
  optional: '(任意)',
  additionalPlaceholder: "{style} スタイルに加えたい要素はありますか? (例:「木製のコーヒーテーブルを追加」「ティールのアクセントカラー」)",
  addAdditionalRequest: '+ 追加リクエストを入れる',
  generateDesign: 'デザインを生成',
  back: '戻る',

  // Generate step
  generatingOne: 'AIがインテリアデザインを生成しています…',
  generatingMany: 'AIが {n} 枚の一貫したインテリアデザインを生成しています…',
  generatingOneExterior: 'AIが外観のリデザインを生成しています…',
  generatingManyExterior: 'AIが {n} 枚の一貫した外観レンダーを生成しています…',
  generatingOneGarden: 'AIが庭のリデザインを生成しています…',
  generatingManyGarden: 'AIが {n} 枚の一貫した庭のレンダーを生成しています…',
  generationFailed: '生成に失敗',
  tryAgain: '再試行',

  // Error messages
  errNoInternet: 'インターネット接続をご確認ください。',
  errTimeout: 'AI の応答がタイムアウトしました。もう一度お試しください。',
  errTooMany: 'リクエストが多すぎます。しばらくしてからお試しください。',
  errNetwork: 'ネットワークエラーが発生しました。接続をご確認ください。',
  errAI: 'AI サービスに問題が発生しました。もう一度お試しください。',
  errFileType: '対応していないファイル形式です。JPEG・PNG・WebP の画像をアップロードしてください。',
  errFileTooLarge: 'ファイルが大きすぎます。20MB 以下の画像をアップロードしてください。',
  errPhotoRead: '写真を読み込めませんでした。別の写真でお試しください。',
  errCameraAccess: 'カメラにアクセスできません。設定でカメラへのアクセスを許可してください。',
  errCameraCapture: '写真を撮影できませんでした。もう一度お試しください。',
  errCaptionSave: 'キャプションを保存できませんでした。もう一度お試しください。',
  imageUnavailable: '画像を表示できません',
  designShareText: 'archelier で作った{style}のデザインです',
  altPhoto: '写真 {n}',
  altOriginal: '元の写真 {n}',
  altGenerated: 'デザイン {n}',
  errInvalidSpace: 'この画像は空間として読み取れませんでした。部屋が写った写真をお使いください — 壁と床が一緒に写っていれば大丈夫です。',
  pickAnotherPhoto: '別の写真を選ぶ',
  errCustomStyle: 'ご希望のスタイルをご記入ください。',
  errSignIn: 'ログインに失敗しました。もう一度お試しください。',
  errInsufficientCredits: 'クレジットを使い切りました。明日もう一度アクセスするとデイリーボーナスを受け取れます。',
  // クレジット1個 = 生成画像1枚。写真N枚ならN個かかる。
  creditCostHint: '写真{n}枚でクレジット{c}個を使います（1枚につき{p}個）。',
  errCreditsShort: 'クレジットが{need}個必要ですが、今は{have}個です。写真を減らすか、お友達を招待して受け取ってください。',

  // Credits
  credits: 'クレジット',
  creditsOne: '{n} クレジット',
  creditsMany: '{n} クレジット',
  outOfCredits: 'クレジットを使い切りました',
  creditModalTitle: 'クレジットを増やす',
  creditModalDesc: '明日には無料クレジットが回復します。それより早く必要ですか?',
  creditModalWallDesc: '今日の無料分は使い切りました。明日また{n}回分が補充されます — 今すぐ続けるならチャージしてください。',
  errOutOfCreditsToday: '今日のクレジットを使い切りました。明日また無料{n}回分が補充されます — 今すぐ続けるならチャージしてください。',
  lastFreeHint: '今日の無料分はこれが最後でした。明日また{n}回分が補充されます。',
  lastFreeHintCta: '今すぐチャージ',
  creditModalChatFree: 'デザイナー Gio とのチャットはこれからも無料です。',
  creditModalGuestTitle: '続けて作るにはログインが必要です',
  creditModalGuestDesc: 'ログインすると毎日無料クレジットがもらえ、保存・共有もできます。',
  creditOptionSignIn: 'ログインして続ける',
  creditOptionSignInDesc: 'Google または Apple アカウントですぐに開始',
  creditOptionInvite: '友達を招待する',
  creditOptionInviteDesc: '友達が登録すると二人とも +{n} クレジット',
  comingSoon: '近日公開',
  close: '閉じる',
  getAppTitle: 'archelier',
  getAppDesc: 'アプリで自分の空間を変えてみる',
  getAppCta: '入手',
  appGateTitle: 'アプリで続ける',
  appGateDesc: 'デザインはアプリが快適です。カメラ、保存、より速い生成。',
  appGateCta: 'アプリを入手',
  appGateNotNow: 'あとで',
  dailyBonusHint: '毎日 {n} クレジットを無料で差し上げます。',
  creditsAria: '残り {n} クレジット',
  accountCreditsTitle: 'クレジット',
  creditsDailyLabel: '毎日補充・深夜0時にリセット',
  creditsBonusLabel: 'ボーナス・有効期限なし',
  creditsResetHint: '毎日 {n} クレジットを無料で差し上げます。招待でもらったボーナスは使うまで残ります。',
  creditsInviteCta: '友達を招待して +{n}',
  creditsTopUpCta: "クレジットをチャージ",
  inviteMenu: '友達を招待',
  profileShare: '共有',
  profileShareText: 'archelier で {name} さんのデザインを見てみてください。',

  // Result step
  original: 'オリジナル',
  aiDesign: 'AI デザイン',
  imageGenFailed: 'この写真の画像生成に失敗しました',
  seeAnalysis: '下のデザイン分析をご確認ください。',
  analysisTitle: 'インテリアデザイン分析',
  spaceAnalysis: '空間分析',
  styleDescription: 'スタイル説明',
  colorPalette: 'カラーパレット',
  furnitureRec: '家具のおすすめ',
  shopFor: '{item} を検索',
  shopShort: 'ショッピング',
  paintMatch: '最も近いペイント',
  paintCodeCopy: 'ペイントコードをコピー',
  paintCodeCopied: 'コードをコピーしました',
  editRegion: '部分編集',
  editRegionTitle: '部分編集',
  editRegionDesc: 'AI に何をどう変えるか伝えてください。それ以外はそのまま保たれます。',
  editRegionBrushHint: '何を変えるか・足すかを書いてください。一か所だけ変えるなら先にそこを塗ります。塗らなければ写真全体を指示どおりに直します。消したいときは塗ってから「消して」と書けばOKです。',
  editRegionMeta: '新規保存 · {n}クレジット',
  editedFromBanner: 'このデザインは部分編集されたコピーです。',
  viewOriginal: 'オリジナルを見る',
  editsOfThisDesign: 'このデザインの編集版',
  editsOfThisDesignDesc: 'このデザインの一部を変えて作った新しいデザインです。',
  chatTitle: 'AI デザインアドバイザー',
  chatHint: 'この部屋についてもっと聞いてみてください。AI がデザインを見ながら答えます。',
  chatStart: '会話を始める',
  chatPlaceholder: '家具 / 色 / 配置について質問…',
  chatSend: '送信',
  chatSending: '考え中…',
  chatSuggestion1: 'この部屋を温かく見せるにはどんな照明が良いですか?',
  chatSuggestion2: 'もっと広く見せるには?',
  chatSuggestion3: 'まず変えるべき 3 つは?',
  chatTurnsRemaining: 'このデザインで残り {n} ターン',
  chatTurnsExhausted: 'このデザインのチャット上限に達しました。新しいデザインを作ると続けられます。',
  chatErrGeneric: 'アドバイザーが回答できませんでした。もう一度お試しください。',
  chatPro: 'Pro — 無制限チャット',
  chatRetry: '再試行',
  commentsTitle: 'コメント',
  commentPlaceholder: 'コメントを書く',
  commentPost: '投稿',
  commentPosting: '投稿中…',
  commentSignInHint: 'ログインするとコメントできます。',
  commentEmpty: 'まだコメントがありません。',
  commentDelete: '削除',
  commentDeleteConfirm: 'このコメントを削除しますか?',
  commentTooLong: 'コメントは 500 文字までです。',
  commentErrGeneric: 'コメント投稿に失敗しました。もう一度お試しください。',
  commentCount: '{n}',
  bookmarksTitle: 'マイコレクション',
  // MyTabs sub-tab 専用 — 既に My ハブ内なので「マイ」prefix 冗長.
  tabDesigns: 'デザイン',
  tabCollections: 'コレクション',
  bookmarksSectionTitle: 'ブックマークしたデザイン',
  bookmarksEmpty: 'まだコレクションがありません。気に入ったデザインを保存するとボードができます。',
  bookmarksAdd: '保存',
  bookmarksAdded: '保存済み',
  bookmarksRemove: '保存から削除',
  bookmarksSignInHint: 'ログインするとデザインを保存できます。',
  saved: '保存済み',
  savedCollectionDefault: '保存済み',
  follow: 'フォロー',
  unfollow: 'フォロー解除',
  following: 'フォロー中',
  followers: 'フォロワー',
  followingTab: 'フォロー中',
  followingEmpty: 'フォローしている人の最新デザインがここに表示されます。',
  followersEmpty: 'まだフォロワーはいません。',
  followingEmpty2: 'まだ誰もフォローしていません。',
  followSignInHint: 'ログインするとフォローできます',
  cannotFollowSelf: '自分自身をフォローすることはできません。',
  profile: 'プロフィール',
  profileNotFound: '存在しないプロフィールです。',
  profileDesigns: 'デザイン',
  profileDesignsCount: 'デザイン',
  profileFollowers: 'フォロワー',
  profileFollowing: 'フォロー中',
  profileBio: '自己紹介',
  profileEdit: 'プロフィールを編集',
  profileMyProfile: 'マイプロフィール',
  displayNameLabel: '表示名',
  displayNamePlaceholder: 'お名前またはスタジオ名 (任意)',
  displayNameSave: '名前を保存',
  displayNameSaved: '名前を保存しました',
  displayNameErrGeneric: '名前の保存に失敗しました。もう一度お試しください。',
  handleLabel: 'ハンドル',
  handlePlaceholder: '小文字、数字、アンダースコア (3-20文字)',
  handleSave: 'ハンドルを保存',
  handleSaved: 'ハンドルを保存しました',
  handleInvalid: 'ハンドルは 3-20 文字、a-z / 0-9 / _ のみ使えます。',
  handleTaken: 'すでに使用中のハンドルです。',
  handleErrGeneric: 'ハンドル保存に失敗しました。もう一度お試しください。',
  bioPlaceholder: '簡単な自己紹介 (200文字以内)',
  bioSave: '自己紹介を保存',
  bioSaved: '自己紹介を保存しました',
  bioErrGeneric: '自己紹介の保存に失敗しました。もう一度お試しください。',
  instagramLabel: 'Instagram',
  instagramPlaceholder: 'Instagramのユーザー名',
  instagramInvalid: '英数字・ピリオド・アンダースコアのみ、最大30文字。',
  profileNoDesigns: 'まだデザインがありません。',
  collections: 'コレクション',
  collectionsTab: 'コレクション',
  collectionMine: 'マイコレクション',
  collectionEmpty: 'まだコレクションがありません。',
  collectionPublicEmpty: '公開コレクションがありません。',
  collectionItemCount: '{n} 件',
  collectionEmpty2: 'このコレクションは空です。',
  newCollection: '新しいコレクション',
  collectionNamePlaceholder: 'コレクション名 (例: リビングのインスピレーション)',
  collectionCreate: '作成',
  collectionDelete: 'コレクションを削除',
  collectionDeleteConfirm: 'このコレクションを削除しますか? すべてのアイテムが削除されます。',
  collectionRename: 'コレクション名を変更',
  collectionVisibility: '公開コレクション',
  collectionVisibilityOn: 'リンクを知っている人なら誰でも見られます',
  collectionVisibilityOff: '自分だけが見られます',
  addToCollection: 'コレクションに追加',
  saveToCollection: 'コレクションに保存',
  collectionAdded: '追加しました',
  collectionRemoveFromBoard: 'コレクションから削除',
  collectionShareLink: 'コレクションリンクをコピー',
  collectionByOwner: 'by',
  collectionNotFound: '存在しないか非公開のコレクションです。',
  collectionErrCreate: 'コレクション作成に失敗しました。',
  collectionErrSave: 'コレクションの更新に失敗しました。',
  collectionDone: '完了',
  collectionPickerHint: 'コレクションをタップしてデザインを追加または削除してください。',
  uploadAcceptsHint: '写真が一番きれいに仕上がります。スケッチ、立面図、間取り図、3D キャプチャも OK。',
  examplePhotos: 'サンプル写真',
  detectedInputTypes: {
    sketch: 'スケッチ',
    elevation: '立面図',
    floorplan: '間取り図',
    '3d_model': '3D モデル',
  },
  floorplanDetectedBanner: '間取り図として認識しました。最も大きな共用空間を人の視点でレンダーしました。他の部屋を見たい場合は、次回の追加リクエストに「主寝室で」のようにご記入ください。',
  floorplanDetectedBannerWithRoom: '間取り図として認識しました。{room} を人の視点でレンダーしました。他の部屋を見たい場合は、次回の追加リクエストに記入してください。',
  spaceCategoryTitle: 'どの空間をデザインしますか?',
  spaceCategories: {
    interior: '室内',
    exterior: '外観',
    garden: '庭',
  },
  exteriorStyles: {
    halloween: { name: 'ハロウィン', description: 'かぼちゃ、ランタン、秋の薄暗い玄関' },
    christmas: { name: 'クリスマス', description: 'リース、暖かな電飾、常緑のガーランド' },
    lunar_new_year: { name: '旧正月', description: '紅い提灯、金の装飾、吉祥の対聯' },
    spring_blossom: { name: '春の桜', description: '花咲く木、パステルの植栽、澄んだ光' },
    modern_facade:        { name: 'モダン・ファサード',      description: 'クリーンな幾何学、大きなガラス窓、ミックスマテリアル' },
    modern_farmhouse:     { name: 'モダン・ファームハウス',   description: 'ホワイトサイディング、ブラックトリム、木のアクセント' },
    mediterranean:        { name: '地中海風',                description: 'スタッコ、テラコッタ、アーチ型開口部' },
    craftsman:            { name: 'クラフツマン',            description: 'ウッドシングル、低い切妻、露出した垂木' },
    contemporary:         { name: 'コンテンポラリー',         description: 'シャープなライン、大胆なボリューム、工業素材' },
    minimalist_exterior:  { name: 'ミニマリスト外観',         description: '抑えたパレット、単一素材の強調' },
    tudor:                { name: 'チューダー',              description: 'ハーフティンバーと急勾配の切妻のイギリス様式' },
    cape_cod:             { name: 'ケープコッド',            description: 'ニューイングランド伝統 — 白シングルに黒シャッター' },
    japanese_traditional: { name: '日本の伝統家屋',           description: '民家風の木造、瓦屋根、縁側' },
    mountain_cabin:       { name: '山小屋キャビン',           description: '丸太または A フレーム、自然の中の山小屋' },
    midcentury_exterior:  { name: 'ミッドセンチュリー外観',     description: '1950–60 年代モダニズム — 平屋根、大きなガラス、水平ライン' },
  },
  gardenStyles: {
    halloween: { name: 'ハロウィン', description: 'かぼちゃ畑、ランタン、霧の秋の庭' },
    christmas: { name: 'クリスマス', description: '灯りのともる常緑樹、暖かな光、冬の庭' },
    lunar_new_year: { name: '旧正月', description: '紅い提灯、梅の枝、吉祥の庭' },
    spring_blossom: { name: '春の桜', description: '桜、チューリップ、春の新緑' },
    modern:         { name: 'モダンガーデン', description: '整った幾何、コンクリート、グラス類' },
    mediterranean:  { name: '地中海', description: '砂利、オリーブとラベンダー、テラコッタ' },
    coastal:        { name: '海辺', description: '草、流木、潮に強い植栽' },
    minimalist:     { name: 'ミニマル', description: '素材も植栽も一種、余白' },
    zen:      { name: '禅ガーデン',           description: '熊手で整えた砂利、石、抑えた植栽' },
    cottage:  { name: 'コテージガーデン',     description: 'ロマンチック、宿根草でいっぱい' },
    desert:   { name: 'デザート / ゼリスケープ', description: '耐乾性植物、多肉植物、砂利' },
    tropical: { name: 'トロピカル',           description: '生い茂る葉、大きな葉、鮮やかな花' },
    english:  { name: 'イングリッシュガーデン', description: '整えられた芝、ヘッジ、レイヤード花壇' },
  },
  seasonLabel: '季節',
  seasons: {
    none: 'いつでも',
    spring: '春',
    summer: '夏',
    autumn: '秋',
    winter: '冬',
  },
  timeOfDayLabel: '時間帯',
  timesOfDay: {
    none: 'いつでも',
    day: '昼間',
    golden_hour: 'ゴールデンアワー',
    night: '夜',
  },
  editRegionReplacementLabel: 'どうしますか？',
  editRegionReplacementPlaceholder: '例：玄関の横に大きな像を置いて',
  editRegionSubmit: '編集を生成',
  editRegionGenerating: '編集された画像を生成しています…',
  editRegionMaskRequired: 'まず変えたい部分を塗ってください。',
  editRegionReplacementRequired: '何に差し替えるか入力してください。',
  editRegionBrush: 'ブラシ',
  editRegionUndo: '元に戻す',
  editRegionSize: '太さ',
  editRegionClear: 'リセット',
  errEditGeneric: '編集に失敗しました。もう一度お試しください。',
  lightingPlan: '照明プラン',
  designTips: 'デザインのヒント',
  startNew: '新しいデザインを始める',
  viewMyDesigns: 'マイデザインを見る',
  favorite: 'お気に入り',
  unfavorite: 'お気に入りから削除',
  rename: '名前を変更',
  savePromptText: '登録すると、このデザインを保存して、共有して、もっと作れます',
  guestCreditsLeft: '無料はあと{n}回です。登録すると{total}回から始められます。',
  guestCreditsGone: '無料体験を使い切りました。登録すると{total}回もらえます。',
  signInGoogle: 'Google でログイン',
  signInApple: 'Apple でログイン',
  signInDesc: 'デザインを保存していつでも見返せます。',
  signInPopupBlocked: 'ポップアップがブロックされました。ブラウザの設定でポップアップを許可してください。',

  // Header / mobile nav
  appName: 'archelier',
  navCreate: '作成',
  navGallery: 'ギャラリー',
  navGio: 'デザイナー',
  navMain: 'メインメニュー',
  packsTitle: "今すぐチャージ",
  packDesigns: "デザイン約 {n} 枚",
  packBuying: "開いています…",
  packWaiting: "支払い完了 — クレジットを追加しています…",
  packDone: "クレジットが追加されました。",
  packSlow: "クレジットはまもなく反映されます。再購入は不要です。",
  packFailed: "購入が完了しませんでした。請求されたのにクレジットが届かない場合はお問い合わせください。",
  gioRole: "空間デザイナー",
  gioAiNote: "AI",
  gioSignInBody: "ログインすると Gio と話せます。部屋の写真やこれまでのデザインを見てスタイルを提案し、チャットからそのまま作成・修正できます。",
  gioGreeting: "こんにちは、Gio です。お部屋の写真、気に入った部屋の画像やリンク、作ったデザインを送ってください。合う方向を提案して、そのまま作ります。",
  gioChipTaste: "私の好みを分析して",
  gioChipTrend: "今週のトレンドは?",
  gioChipPhoto: "部屋の写真を送る",
  gioChipMine: "自分のデザインを読み込む",
  gioTyping: "Gio が考えています…",
  gioPlaceholder: "Gio に聞くか、リンクを貼り付け",
  gioSend: "送信",
  gioAttachPhoto: "写真を添付",
  gioPickDesign: "マイデザイン",
  gioPickEmpty: "まだデザインがありません。まず作ってから読み込んでください。",
  gioRemove: "外す",
  gioToday: "今日",
  gioNoCredits: "クレジットがなくなりました。",
  gioError: "Gio が応答できませんでした。もう一度送ってください。",
  gioAlreadyStarting: "すでに開始しています。少々お待ちください。",
  gioPhotoSkipped: "一部の写真を追加できませんでした。添付できるのは最大{n}枚（20 MB未満のJPG、PNG、WebP、HEIC）までです。",
  gioErrPhotos: "写真が見つかりませんでした。お部屋の写真を追加して、もう一度お試しください。",
  gioErrPrompt: "Gioがデザインを作成できませんでした。少し表現を変えてお試しください。",
  gioErrGone: "このデザインや提案は利用できなくなりました。",
  gioCreditsLow: "残り {n} クレジット · メッセージ {c}、写真付きは {p}",
  gioCreditsLowFree: "残り {n} クレジット · チャットは無料",
  gioNoCreditsChatFree: "デザイン用のクレジットはなくなりました — チャットは引き続き無料です。",
  gioDailyLimit: "今日はたくさん話しましたね。続きはまた明日。",
  gioCardEdit: "修正",
  gioCardPhotos: "写真 {n} 枚",
  gioCardPhotoFromDesign: "{date}のデザインの写真",
  gioCardPhotoFromDesignNoDate: "以前のデザインの写真",
  gioCardPhotoFromChat: "チャットに送った写真",
  gioCardPhotoNew: "新しい写真",
  gioCardNoPhoto: "まだ写真がありません",
  gioCardChangePhoto: "変更",
  gioCardAddPhoto: "写真を追加",
  gioCardUploading: "アップロード中…",
  gioCardSame: "この写真の{style}デザインはすでにあります（{date}）。",
  gioCardSameView: "見る",
  gioCardSameHint: "追加リクエストが同じだと、ほぼ同じ仕上がりになります。変えたいときは上で追加リクエストを入れるか、チャットでGioに伝えるか、作成画面で開いて調整してください。",
  gioPickPhoto: "写真を選ぶ",
  gioPickUpload: "新しい写真をアップロード",
  gioRunEdit: "修正する · {n} クレジット",
  gioRunGenerate: "作成 · {n} クレジット",
  gioRunWithPhoto: "写真を選んで作成 · 1枚 {n}",
  gioOpenInCreate: "作成画面で開く",
  gioPaintMyself: "自分で塗る",
  gioStarting: "開始中…",
  gioJobMaking: "デザインを作成中…",
  gioJobEditing: "デザインを修正中…",
  gioJobNotify: "ほかの画面に移っても大丈夫。できたらお知らせします。",
  gioJobInvalid: "デザインできる空間の写真ではないようです。",
  gioJobFailed: "今回は完成できませんでした。",
  gioJobRefunded: "クレジットはお返ししました。",
  gioJobDone: "できました — 見る",
  gioJobGone: "削除されたデザインです。",
  gioAskAboutDesign: "このデザインを Gio に相談",
  navFeed: 'フィード',
  navMy: 'マイ',
  navAccount: '設定',
  signIn: 'ログイン',
  signOut: 'ログアウト',
  deleteAccount: 'アカウントを削除',
  deleteAccountTitle: 'アカウントを削除しますか？',
  deleteAccountWarn: 'アカウントと、それに関連するすべてのデータが完全に削除されます。この操作は取り消せません。',
  deleteAccountItem_designs: 'すべてのデザインと画像、Gio との会話',
  deleteAccountItem_profile: 'プロフィール、ハンドル、保存したスタイル',
  deleteAccountItem_social: 'コメント、いいね、フォロー、コレクション',
  deleteAccountItem_credits: '残りのクレジット（購入分を含む）とサブスクリプション履歴',
  deleteAccountBilling_web: 'ウェブのサブスクリプションは自動的に解約されます。',
  deleteAccountBilling_ios: 'App Store・Google Play のサブスクリプションは自動解約されません。ストアのサブスクリプション設定から直接解約してください。',
  deleteAccountFinal: 'ただちにログアウトされ、このアカウントは復元できません。',
  deleteAccountConfirm: 'アカウントを削除',
  deleteAccountSubmitting: '削除中…',
  deleteAccountError: 'アカウントを削除できませんでした。もう一度お試しください。',
  myDesigns: 'マイデザイン',
  language: '言語',
  support: 'サポート',
  deleteAccount: 'アカウント削除',
  terms: '利用規約',
  privacy: 'プライバシーポリシー',
  signInTerms: 'ログインすると {terms} および {privacy} に同意したことになります。',

  // Onboarding
  onboardingSkip: 'スキップ',
  onboardingNext: '次へ',
  onboardingStart: 'はじめる',
  tourTitle: 'archelier のご案内',
  tourCreate: 'ここから始めます。部屋・外観・庭の写真を撮るかアップロードしてスタイルを選ぶと、まもなく新しいデザインができあがります。',
  tourGallery: 'ギャラリーです。今週 archelier でよく選ばれたスタイルが集まっていて、タップすると自分の空間ですぐ試せます。',
  tourGio: 'デザイナーの Gio です。写真を見せて希望を伝えると、スタイルを提案し、デザインを作ったり直したりします。',
  tourMy: '作ったデザインはマイに集まります。直したい部分だけ塗るか言葉で伝えて修正でき、ダウンロードや共有もここから。',
  tourStart: '新しいデザインはいつでもこのボタンから。写真1枚で始めてみましょう。',
  tourReplay: 'ご案内をもう一度見る',
  onboarding: [
    {
      icon: 'photo_camera',
      title: '写真もスケッチも図面も OK',
      desc: 'スマホの写真が一番良いですが、手描きスケッチ、立面図、間取り図、3Dモデルのスクショも自動で認識します。',
    },
    {
      icon: 'style',
      title: '19+ スタイル・4 つのモード',
      desc: 'プリセットスタイル、自由記述のカスタム、好きな写真のトーンを真似する Reference、片付け(Cleanup) や家具配置(Layout) モードも。',
    },
    {
      icon: 'brush',
      title: '一部だけ描き直し',
      desc: '一部分だけ変えたい時は、結果の上に塗って何に置き換えるか伝えるだけ。それ以外はピクセル単位で保たれます。',
    },
    {
      icon: 'auto_awesome',
      title: '今すぐ作ってみよう',
      desc: '毎日無料クレジットを差し上げます。写真をアップロードすれば 1 分ほどで最初のデザインが完成します。',
    },
  ],

  // モバイル spotlight オンボーディング — タブを一つずつ短く。
  onboardTabFeedTitle: 'まずは眺めてみよう',
  onboardTabFeedDesc: '他の人の空間を見てインスピレーションを受け取れます。',
  onboardTabCreateTitle: 'AI で自分の空間を',
  onboardTabCreateDesc: '写真・スケッチ・図面をアップロードすると、AI が新しいデザインを作ります。',
  onboardTabMyTitle: '保存と管理',
  onboardTabMyDesc: '作ったデザインはここに集まり、フィードへ共有もダウンロードもできます。',
  onboardTabGioTitle: "Gio に相談",
  onboardTabGioDesc: "空間デザイナーの Gio が写真からスタイルを提案し、チャットでそのまま作成・修正します。",

  // My Designs page
  myDesignsTitle: 'マイデザイン',
  signInToSee: 'ログインすると保存したデザインが見られます',
  signInToSeeDesc: '保存したデザインがここに表示されます。',
  loadingDesigns: 'デザインを読み込んでいます…',
  errLoadDesigns: 'デザインを読み込めませんでした。もう一度お試しください。',
  retry: '再試行',
  noFavorites: 'お気に入りに登録したデザインがありません。',
  noDesigns: 'まだデザインがありません。最初のデザインを作ってみましょう!',
  createDesign: 'デザインを作る',
  loadMore: 'もっと見る',

  // Design detail
  loading: '読み込み中…',
  errDesignNotFound: 'デザインが見つかりませんでした。',
  errLoadDesign: 'デザインを読み込めませんでした。',
  errDeleteDesign: '削除に失敗しました。もう一度お試しください。',
  renameTitle: '名前を変更',
  // rename 모달 placeholder — 하나만 두면 다들 그 문구를 그대로 쓴다.
  // 열 때마다 무작위로 하나 고른다 (공간 종류·버전 표기를 섞어 둬서
  // "이렇게 편하게 적으면 된다" 가 읽히게).
  renamePlaceholders: [
    'リビングのリモデル案 1',
    'キッチン — 明るめ',
    'アトリエ改装',
    '寝室、暖かいトーン',
    'バルコニー B 案',
    '書斎のセットアップ',
    'カフェ内装ドラフト',
    '前庭 案2',
  ],
  save: '保存',
  cancel: 'キャンセル',
  deleteTitle: 'デザインを削除しますか?',
  deleteDesc: 'このデザインとすべての画像が永久に削除されます。この操作は取り消せません。',
  delete: '削除',
  deleting: '削除中…',
  postToFeed: 'フィードに投稿',
  postedToFeedTitle: 'フィードに投稿しました',
  postedToFeedDesc: '他のユーザーがフィードでこのデザインを見ていいねできるようになりました。',
  captionTitle: 'ひとこと添える',
  captionPlaceholder: 'なぜこの空間をリデザインしたかったか、教えてください（任意）',
  captionEdit: 'キャプションを編集',
  captionPost: '投稿',
  captionSave: '保存',
  captionCancel: 'キャンセル',
  viewFeed: 'フィードを見る',
  generationInProgress: 'デザインを作っています…',
  generationKeepBrowsing: '他のページを見ていても大丈夫です。完成したらお知らせします',
  generationDone: 'デザインが完成しました!',
  generationTapToOpen: '「開く」を押すと結果が見られます',
  generationFailed: '生成に失敗',
  generationFailedHint: 'クレジットは消費されていません。もう一度お試しください。',
  open: '開く',
  tryAgain: '再試行',
  copy: 'コピー',
  copied: 'コピーしました!',
  share: 'シェア',
  downloadImages: 'AI 画像をダウンロード',
  download: 'ダウンロード',
  downloadWatermarkHint: '画像の右下に小さく archelier の署名が入ります。',
  modes: {
    redesign: 'リデザイン',
    staging: '空室ステージング',
  },
  styleUsed: '使用したスタイル',
  customDescLabel: 'カスタム説明:',
  additionalReqLabel: '追加リクエスト:',
  useStyleAgain: 'このスタイルでもう一度試す',

  // Community feed
  feedTitle: 'コミュニティ',
  feedEmpty: 'まだ公開されているデザインがありません。最初の一人になりましょう!',
  feedSortLatest: '新着順',
  feedSortPopular: '人気順',
  feedFilterAll: 'すべて',
  useThisStyle: 'このスタイルで始める',
  sourceDesignBanner: '"{name}" のデザインを参考にしています',
  galleryPickBanner: '{name} スタイルで作ります',
  signInToLike: 'いいねするにはログインが必要です',

  // Share view
  tryApp: 'archelier を試す',
  privateTitle: '非公開のデザインです',
  privateDesc: 'このデザインはまだ公開されていません。',
  linkNotFoundTitle: 'このリンクは開けません',
  linkNotFoundDesc: 'デザインが削除されたか、リンクが途中で切れている可能性があります。',
  createWithApp: 'archelier でデザインを作る',
  shareViewCTA: 'あなたの空間もリデザインしてみませんか?',

  // Interior styles
  styles: {
    modern:       { name: 'モダン',              description: 'クリーンなライン、ニュートラルなトーン、現代的なミニマリズム' },
    scandinavian: { name: 'スカンジナビアン',      description: '明るく自然な素材、温かい北欧の感性' },
    ikea:         { name: 'IKEA',                description: '実用的でアクセスしやすいスカンジナビアの日常デザイン' },
    japandi:      { name: 'ジャパンディ',         description: '日本のミニマリズムとスカンジナビアの温もりの調和' },
    industrial:   { name: 'インダストリアル',     description: '生の素材、露出した要素、都会的なロフトの美学' },
    coastal:      { name: 'コースタル',           description: '爽やかで光に満ちた海辺の別荘の感性' },
    classic:      { name: 'クラシック',           description: '時代を超えたエレガンス、上質なファブリック、装飾的なディテール' },
    artdeco:      { name: 'アール・デコ',         description: '大胆な幾何学、ゴールドのアクセント、1920 年代の華やかさ' },
    midcentury:   { name: 'ミッドセンチュリーモダン', description: '有機的なフォルム、温かい木目、1950〜60 年代のレトロ感' },
    maximalist:   { name: 'マキシマリスト',       description: '大胆なパターン、豊かなレイヤリング、多ければ多いほどよい' },
    vintage:      { name: 'ヴィンテージ',         description: 'ノスタルジックな魅力、アンティーク小物、温かいレトロパレット' },
    bohemian:     { name: 'ボヘミアン',           description: '自由な精神、カラフルなテキスタイル、芸術的折衷主義' },
    tropical:     { name: 'トロピカル',           description: '生い茂る植物、ラタン、爽やかなリゾート感' },
    cottagecore:  { name: 'コテージコア',         description: 'ロマンチックな英国カントリー、花柄、優しいパステル' },
    rustic:       { name: 'ラスティック',         description: '風化した木、石、温かみあるファームハウス' },
    wabisabi:     { name: '侘び寂び',            description: '不完全な美、生の質感、静かな日本的禁欲' },
    gothic:       { name: 'ゴシック',            description: '陰影あるドラマ、ベルベット、華麗なシルエット' },
    cyberpunk:    { name: 'サイバーパンク',       description: 'ネオンの未来主義、ハイテクな表面、都市ディストピア' },
    taisho_romance: { name: '大正ロマン',         description: '20世紀初頭の日本と西洋アール・ヌーヴォーの融合' },
    biophilic:    { name: 'バイオフィリック',     description: '植物いっぱい、自然光、有機的な質感' },
    cozy:         { name: 'コージー',            description: '温かく柔らかい、ヒュッゲ的な居心地よさ' },
    gaming:       { name: 'ゲーミング',          description: 'RGB セットアップ、洗練されたテック、没入型バトルステーション' },
    minimalist:     { name: 'ミニマル', description: '削ぎ落とした構成、余白重視' },
    mediterranean:  { name: '地中海', description: 'ライムウォッシュ、テラコッタ、アーチ、石' },
    luxury:         { name: 'クワイエットラグジュアリー', description: '上質な素材、抑えた色、控えめ' },
    dark_academia:  { name: 'ダークアカデミア', description: '書斎風 — 深紅、真鍮、積まれた本' },
    organic_modern: { name: 'オーガニックモダン', description: 'モダンな形に素材そのもの' },
    farmhouse:      { name: 'ファームハウス', description: '板張り、エプロンシンク、古材' },
    halloween:      { name: 'ハロウィン', description: 'かぼちゃ、キャンドル、秋の暗がり' },
    christmas:      { name: 'クリスマス', description: 'ツリー、ガーランド、暖かな灯り' },
    lunar_new_year: { name: '旧正月', description: '紅と金、提灯、吉祥文様' },
    spring_blossom: { name: '春の桜', description: '桜、パステル、澄んだ春の光' },
    custom:       { name: 'カスタムスタイル',     description: 'あなただけのインテリアビジョンを直接ご記入ください' },
    reference:    { name: 'リファレンス',         description: 'お気に入りの写真のトーン・素材・雰囲気をそのまま適用' },
    floorplan:    { name: '間取り図', description: '間取り図から3D間取り図やきれいな図面を' },
    cleanup:      { name: 'クリーンアップ',        description: '散らかりだけ整理するか、空っぽの部屋にするか選べます' },
    layout:       { name: 'レイアウト',          description: '家具そのまま、配置だけ — 動線または広く感じる' },
  },

  langMismatchNotice: 'この分析は {lang} で生成されました。',

  // Pricing page
  pricingTitle: 'ニーズに合わせて選べるプラン',
  pricingSubtitle: '無料で始めて、もっと多くの生成が必要になったらアップグレード。',
  pricePerMonth: '/ 月',
  trialCta: '{n}日間の無料体験を始める',
  accountPlanFreeTitle: 'アカウントは FREE です',
  accountPlanProTitle: 'Pro プランご利用中',
  accountPlanTrialTitle: 'Pro 無料トライアル中',
  proTrialBadge: 'トライアル',
  proTrialDaysLeft: '無料トライアル残り {n} 日',
  proTrialIntroTitle: '2 週間 Pro 無料トライアル',
  proTrialIntroDesc: '登録すると無料クレジット {n} 個でスタート。',
  proTrialFeatures: 'その後も毎日 {n} 個ずつ。サブスクはありません。',
  welcomeSkip: 'アカウントなしで続ける',
  // Marketing landing (/landing)
  landingHeadline: 'どんな部屋でも、数秒で新しいデザイン。',
  landingTagline: '写真を撮って、スタイルを選ぶだけ。フォトリアルなインテリアレンダーが届きます。毎日無料、サブスクなし。',
  landingOpenWeb: 'ウェブで続ける →',
  landingFeat1: 'AI インテリアレンダー',
  landingFeat2: 'フォトリアル',
  landingFeat3: '50+ スタイル',
  landingFeat4: '庭・外観',
  landingFeat5: '毎日無料',
  landingStoreOn: 'ダウンロード',
  landingStoreGet: 'ダウンロード',
  // ランディング本文 (lp.*) — en.js の lp と同じキー。言語別静的ページ(/ja)・JSON-LD の原本。
  lp: {
    metaTitle: 'archelier — 写真1枚からAIインテリアデザイン',
    metaDescription: '部屋の写真1枚で、約1分でフォトリアルなリデザイン。室内・外観・庭の48スタイル、3D間取り図、部分編集、相談できるAIデザイナーも。毎日無料。',
    heroEyebrow: 'AIインテリアデザイン',
    scrollCue: '使い方を見る',
    webCta: 'ブラウザで無料で試す',
    orApp: 'アプリで使う',
    qrHint: 'スマホのカメラで読み取ってください。アプリならデザインが完成した瞬間にお知らせします。',
    showEyebrow: 'ビフォー & アフター',
    showTitle: '写真1枚で、まったく新しい部屋に。',
    showBody: 'archelier で作った実際の結果です。ドラッグして比べてみてください。',
    before: 'ビフォー',
    after: 'アフター',
    tabRoom: 'リビング',
    tabEmpty: '空室',
    tabSketch: 'スケッチ',
    tabPlan: '間取り図',
    tabExterior: '外観',
    capRoom: 'ラスティック — 同じキッチンとリビングを、あたたかく。',
    capEmpty: 'スカンジナビアン — 空っぽの部屋に家具を。',
    capSketch: 'ジャパンディ — 線画スケッチを本物の空間に。',
    capPlan: '間取り図モード — 2Dの間取り図を家全体の3Dビューに。',
    capExterior: 'ミニマル — にぎやかな店構えを一新。',
    howEyebrow: '使い方',
    howTitle: '3ステップ、約1分。',
    how1Title: '写真を撮る',
    how1Body: 'いまのままの部屋を — スケッチ、間取り図、3Dのスクリーンショットでも。同じ部屋を最大3枚まで。',
    how2Title: 'スタイルを選ぶ',
    how2Body: '48のスタイルから選ぶか、ひとことで説明するか、好きな写真をアップロード。',
    how3Title: 'デザインが届く',
    how3Body: 'あなたの空間のフォトリアルなレンダーに、家具リスト・カラーパレット・照明プランつき。',
    stylesEyebrow: 'スタイル',
    stylesTitle: '3つの空間に、48のスタイル。',
    stylesBody: '室内28、外観11、庭9 — さらにハロウィン・クリスマス・旧正月・春の季節スタイルも。',
    stylesInterior: '室内',
    stylesExterior: '外観',
    stylesGarden: '庭',
    stylesCta: 'スタイルギャラリーを見る',
    modesEyebrow: 'スタイルの先へ',
    modesTitle: '空間に向き合う、5つの方法。',
    modeCustomTitle: 'カスタムスタイル',
    modeCustomBody: 'イメージをひとことで書いて、次からも使えます。',
    modeReferenceTitle: 'リファレンス',
    modeReferenceBody: '好きな写真から、レイアウトではなくトーン・素材・色合いだけを取り入れます。',
    modeCleanupTitle: '片付け',
    modeCleanupBody: 'ごちゃごちゃを片付けて、空っぽの部屋を見られます。',
    modeLayoutTitle: 'レイアウト',
    modeLayoutBody: '家具を替えずに、いまある家具の配置だけを見直します。',
    modePlanTitle: '間取り図',
    modePlanBody: '間取り図を家全体の3Dビューに、ラフなスケッチをきれいな図面に。',
    editEyebrow: '部分編集',
    editTitle: 'ひとつずつ、変えていく。',
    editBody: 'ソファだけが気に入らない？ 丸で囲んで、ほしいものを書くだけ。archelier はその部分だけを描き直し、ほかはそのまま — 壁の色、ラグ、照明、アートも同じです。',
    editPrompt: 'ヴィンテージのレザーソファ',
    shopTitle: '見たまま、買える。',
    shopBody: 'どのデザインにも家具リスト・カラーパレット・照明プランがつき、家具ごとに似たアイテムを探すリンクがあります。',
    gioEyebrow: 'Gio',
    gioTitle: 'デザイナーに相談するように。',
    gioBody: 'Gio は専用タブにいるAI空間デザイナー。部屋の写真、好きな空間の写真やリンク、あなたのデザインを送ると、方向性を提案し、チャットの中でデザインを作ったり直したりします。',
    gioRole: '空間デザイナー',
    gioUser: 'うちのキッチンとダイニングです。ちょっと冷たい感じがして。何かアイデアありますか？',
    gioReply: '硬い素材の代わりに、あたたかい木、やわらかなファブリック、低めの間接照明を重ねてみましょう。こんな方向はどうでしょう：',
    gioCardTitle: 'あたたかなジャパンディ',
    gioCardBody: 'ナチュラルオークと質感のある塗り壁で、空間にすぐぬくもりが生まれます。',
    gioCardAction: '作る',
    priceEyebrow: '料金',
    priceTitle: '毎日無料。サブスクなし。',
    price1: '毎日の無料デザイン、現地時間の0時にリセット',
    price2: 'アカウント作成でボーナス',
    price3: '友だちを招待すると、ふたりとももらえる',
    price4: 'もっと使うならクレジットパックで',
    privacyTitle: 'あなたの写真は、あなたのもの。',
    privacyBody: '写真・リクエスト・デザインがAIの学習や広告に使われることはありません。共有しない限り、デザインはあなただけのものです。',
    faqTitle: 'よくある質問',
    faq1Q: 'archelier とは？',
    faq1A: 'archelier（Architect + Atelier）は、スマホとウェブで使えるAIインテリアデザインアプリです。部屋を撮ってスタイルを選ぶと、その空間そのもののフォトリアルなリデザインが届き、家具ひとつひとつに名前とリンクがつきます。室内だけでなく外観や庭にも対応しています。',
    faq2Q: 'どうやって使うの？',
    faq2A: '部屋の写真を撮るか、スケッチ・間取り図・3Dのスクリーンショットをアップロードします。48のスタイルから選ぶか、自分で説明するか、参考写真をアップロード。約1分で、空間のフォトリアルなレンダーと家具リスト・カラーパレット・照明プランが届きます。',
    faq3Q: '無料ですか？',
    faq3A: 'はい。サブスクはありません。毎日無料のデザインがあり（現地時間の0時にリセット）、アカウント作成や友だち招待でボーナスももらえます。もっと使いたいときはクレジットパックを購入できます。',
    faq4Q: '間取り図を3Dにできますか？',
    faq4A: 'はい。間取り図モードは、2Dの間取り図を選んだスタイルで家全体の3Dビューにします。手描きのスケッチやぼやけた図面を、きれいな図面やカラーの間取り図にすることもできます。',
    faq5Q: '好きな写真のスタイルに合わせられますか？',
    faq5A: 'はい。リファレンスを選んで参考写真をアップロードしてください。レイアウトはまねせず、トーン・素材・色合いを取り入れてあなたの部屋に反映します。',
    faq6Q: 'デザインの一部だけ変えられますか？',
    faq6A: 'はい。ソファ、ラグ、壁など、変えたい部分を丸で囲んで、ほしいものを書くだけ。その部分だけが描き直され、ほかはそのまま残ります。',
    faq7Q: 'Gio とは？',
    faq7A: 'Gio は archelier のAI空間デザイナーです。部屋の写真、好きな空間の写真やリンク、あなたのデザインを送ると、方向性を提案し、チャットの中でデザインを作ったり直したりし、色・予算・照明の質問にも答えます。',
    faq8Q: '写真がAIの学習に使われますか？',
    faq8A: 'いいえ。archelier は写真・リクエスト・デザインをAIモデルの学習や広告に使いません。共有しない限り、デザインはあなたのアカウントだけに表示されます。',
    faq9Q: 'どこで使えますか？',
    faq9A: 'App Store、Google Play、そしてウェブの archelier.co で。アカウントとデザインはどこでも同期されます。11言語に対応しています。',
    ctaTitle: '今日、部屋を新しく。',
    ctaBody: 'スマホでも、ウェブでも。デザインはどこでもつながります。',
    langLabel: '言語',
  },
  upgradeToPro: 'Pro にアップグレード',
  creditsPerMonth: '毎月 {n} クレジット',
  planFreeName: '無料',
  planFreeTagline: '毎月いくつかのデザインで archelier を体験。',
  planProName: 'Pro',
  planProTagline: '質の高い結果を求める一般ユーザー向け。',
  planStudioName: 'Studio',
  planStudioTagline: 'パワーユーザー、チーム、商用利用向け。',
  planFeatWatermark: '「archelier」のウォーターマーク入り',
  planFeatNoWatermark: '保存・共有時にウォーターマークなし',
  planFeatUnlimited: '無制限のAIデザイン生成',
  planFeatUnlimitedChat: 'デザインごとのAIチャット無制限 (無料は3回)',
  planFeatUnlimitedEdit: '部分編集無制限',
  planFeatFeed: 'フィードに投稿',
  planFeatEverythingPro: 'Pro のすべての機能を含む',
  planFeatCommercial: '商用利用権',
  planFeatApiAccess: 'API アクセス (近日公開)',
  planCtaSubscribe: '契約する',
  planCtaCurrent: '現在のプラン',
  planPopular: '一番人気',
  signInToSubscribe: 'ログインして契約',
  signInToBuy: 'ログインして購入',
  trialNote: '{n} 日間無料体験',

  creditPacksTitle: 'またはクレジットパックでチャージ',
  creditPacksSubtitle: '契約なしで必要なときに 1 回支払い。',
  packStarterName: 'スターターパック',
  packStandardName: 'スタンダードパック',
  packProName: 'プロパック',
  packCreditsAmount: '{n} クレジット',
  packCtaBuy: '購入',
  pricingFootnote: '表示価格は USD で、決済時に税が加算されます。いつでも解約可能。',
  errBillingGeneric: 'リクエスト処理中に問題が発生しました。もう一度お試しください。',

  // Account page
  accountTitle: '設定',
  accountPlanSection: 'プラン',
  accountCreditsSection: 'クレジット',
  accountCreditsDesc: 'デザイン生成時にクレジットが消費されます。いつでもチャージできます。',
  viewPlans: 'プランを見る',
  changePlan: 'プランを変更',
  manageBilling: '支払いを管理',
  manageBillingWebHint: 'ウェブから登録された場合は archelier.co で管理できます。',
  buyCreditPack: 'クレジットパックを購入',
  subRenewsAt: '{date} に更新',
  subEndsAt: '{date} に終了',
  trialEndsAt: '{date} に無料体験終了 — $9.99/月で自動継続',
  trialCancelEndsAt: '{date} に体験終了 — 自動更新なし',
  subStatus_past_due: 'お支払いが滞っています。お支払い方法を更新してください。',
  subStatus_canceled: '契約は解約されました。',
  subStatus_unpaid: 'お支払い未完了の状態です。',
  subStatus_trialing: '無料体験中です。',
  account: 'アカウント',
  pricing: '料金',
  upgrade: 'アップグレード',

  // Invite / promo page
  inviteTitle: '友達を招待してクレジットをゲット',
  inviteSubtitle: '友達があなたのリンクから登録すると、あなたは +{inviter} クレジット、友達は +{invitee} クレジットを受け取ります。',
  inviteFriends: '友達を招待',
  inviteSignInHint: 'ログインすると招待リンクを取得できます。',
  yourReferralCode: '招待リンク',
  inviteCodeLoading: '招待リンクを準備しています…',
  inviteLinkHint: 'あなたのリンクから登録した友達は +{n} クレジットを受け取ります。',
  copyLink: 'リンクをコピー',
  shareLink: 'リンクをシェア',
  inviteShareText: 'archelier で AI を使って空間をリデザインしてみませんか? 私のリンクから登録すると +{n} クレジットがもらえます。',
  redeemTitle: 'コードをお持ちですか?',
  redeemDesc: '友達からの招待コードやプロモコードを入力するとボーナスクレジットがもらえます。',
  copyCode: 'コードをコピー',
  errRefSelf: '自分の招待コードは使えません。',
  landingInviteTitle: '友達から招待されました — 二人とも +{n} クレジット。',
  landingInviteAutoIos: "アプリをインストールしたら、この招待リンクをもう一度タップしてください。アプリが開き、登録すると自動で適用されます。",
  landingInviteAutoAndroid: "下の Google Play ボタンからインストールして登録すると、自動で適用されます。適用されていない場合は、設定 → 友達を招待 でこのコードを入力してください。",
  landingInviteDesktop: "ここで登録するとすぐに適用されます。スマホのアプリで受け取るには、QRコードを読み取ってスマホに表示される案内に従ってください。",
  promoTitle: 'プロモコードはお持ちですか?',
  promoDesc: 'プロモコードを入力するとクレジットがもらえます。',
  promoPlaceholder: '例: LAUNCH2026',
  promoRedeem: '適用',
  promoSuccess: '適用完了 — {n} クレジットが追加されました。',
  errPromoInvalid: '有効でないコードです。',
  errPromoExpired: '期限切れのコードです。',
  errPromoMaxed: '使用上限に達したコードです。',
  errPromoUsed: 'すでに使用したコードです。',
  errPromoUserInit: 'ページを再読み込みしてからもう一度お試しください。',
  errPromoGeneric: 'コードの適用に失敗しました。もう一度お試しください。',

  // Reports / moderation (Phase 8-4)
  reportThisDesign: 'このデザインを通報',
  reportShort: '通報',
  reportTitle: 'デザインを通報',
  reportDesc: 'どんな問題がありますか? 通報内容は管理者だけが確認できます。',
  reportReason_spam: 'スパム / 広告',
  reportReason_nsfw: '性的 / 不適切なコンテンツ',
  reportReason_copyright: '著作権侵害',
  reportReason_other: 'その他',
  reportNotePlaceholder: '追加説明 (任意、500 文字以内)',
  reportSubmit: '通報を送信',
  reportSubmitting: '送信中…',
  reportSignInHint: '通報するにはログインが必要です。',
  reportThanks: '通報を受け付けました',
  reportThanksDesc: '確認の上、必要な対応を取らせていただきます。ありがとうございます。',
  errReportGeneric: '通報の送信に失敗しました。しばらくしてからお試しください。',

  // ブロック機能 (App Review Guideline 1.2)
  blockUser: 'このユーザーをブロック',
  unblockUser: 'ブロック解除',
  blockShort: 'ブロック',
  blockConfirm: '@{handle} さんをブロックしますか?ブロックすると、このユーザーのデザインがフィード/プロフィールから非表示になり、相互にやり取りできなくなります。',
  blockedUsersMenu: 'ブロックしたユーザー',
  blockedUsersTitle: 'ブロックしたユーザー',
  blockedUsersDesc: 'ブロックしたユーザーの一覧です。これらのユーザーのデザインはフィードとプロフィールから非表示になります。',
  blockedUsersEmpty: 'ブロックしたユーザーはいません。',
  profileBlocked: 'このユーザーをブロックしています。',
  profileBlockedAction: 'ブロックを解除すると再びデザインが表示されます。',
  errBlockGeneric: 'ブロック状態の変更に失敗しました。もう一度お試しください。',
  errBlockedCustomCommand: '入力したリクエストに許可されていない単語が含まれています。',
  moderationAutoUnlisted: 'このデザインは自動レビューによりフィードから外されました。問題がないとお考えの場合は管理者にお問い合わせください。',

  // Language name used in AI prompt
  promptLang: 'Japanese',
};
